// extracted by mini-css-extract-plugin
export default {"fixed":"container_fixed__axJ6E","narrow":"container_narrow__-iO9-","medium":"container_medium__4RRNA"};